import { useEffect } from 'react';

const HubspotForm = ({ portalId, formId, userEmail, workspaceId }) => {
  useEffect(() => {
    const scriptId = 'hubspot-form-script';
    const container = document.getElementById('hubspotFormContainer');
    let script = document.getElementById(scriptId);

    const createForm = () => {
      if (!window.hbspt) return;

      // Tell HubSpot who this user is before the form iframe loads.
      // This is the only cross-origin-safe pre-fill mechanism for the new iframe embed.
      if (userEmail) {
        window._hsq = window._hsq || [];
        window._hsq.push(['identify', { email: userEmail }]);
      }

      const fieldValues = {
        workspace_feedback_url: window.location.href,
        ...(userEmail ? { email: userEmail, '0-1/email': userEmail } : {}),
        ...(workspaceId ? { workspace_id: workspaceId } : {}),
      };
      console.log('[HubspotForm] calling hbspt.forms.create', { userEmail, fieldValues });
      window.hbspt.forms.create({
        portalId,
        formId,
        target: '#hubspotFormContainer',
        fieldValues,
        onFormReady: function($form, ctx) {
          console.log('[HubspotForm] onFormReady', { ctx, hasSetFieldValue: ctx && typeof ctx.setFieldValue === 'function', userEmail });
          // Newer HubSpot embed passes ctx with setFieldValue — use it if available
          if (ctx && typeof ctx.setFieldValue === 'function') {
            ctx.setFieldValue('workspace_feedback_url', window.location.href);
            if (userEmail) ctx.setFieldValue('0-1/email', userEmail);
            if (workspaceId) ctx.setFieldValue('workspace_id', workspaceId);
          }

          // Direct DOM: field pre-fill fallback + data-form-type on all text fields
          const formEl = $form && ($form[0] || $form);
          if (!formEl || !formEl.querySelector) return;

          if (!ctx) {
            const urlInput = formEl.querySelector('input[name="workspace_feedback_url"]');
            if (urlInput) urlInput.value = window.location.href;

            if (userEmail) {
              const emailInput = formEl.querySelector('input[name="0-1/email"]');
              if (emailInput) {
                emailInput.value = userEmail;
                emailInput.dispatchEvent(new Event('input', { bubbles: true }));
                emailInput.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }

            if (workspaceId) {
              const workspaceInput = formEl.querySelector('input[name="workspace_id"]');
              if (workspaceInput) {
                workspaceInput.value = workspaceId;
                workspaceInput.dispatchEvent(new Event('input', { bubbles: true }));
                workspaceInput.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          }

          formEl.querySelectorAll('input[type="text"], textarea')
            .forEach(el => el.setAttribute('data-form-type', 'other'));
        }
      });
    };

    if (script) {
      createForm();
    } else {
      script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://js.hsforms.net/forms/v2.js';
      document.body.appendChild(script);
      script.onload = createForm;
    }

    return () => {
      if (container) container.innerHTML = '';
    };
  }, [portalId, formId, userEmail, workspaceId]);

  return <div id="hubspotFormContainer"></div>;
};

export default HubspotForm;
